import ClockoutController from '../../../core/clockout.controller';
import Inherit from '../../../core/inherit';
import NewSidebarDelegate from './newSidebar.delegate';
import { navbarSections } from './navbar.constants';
import { NAVBAR_ACTIVE_PATH_ALIASES } from './navbar.paths';

class NewSidebarController extends Inherit(ClockoutController, NewSidebarDelegate) {
    /**
     * @param {typeof navbarSections} [sections]
     * @returns {Set<string>}
     */
    collectNavbarPaths(sections = navbarSections) {
        const paths = new Set();

        const walk = (items) => {
            for (const item of items) {
                if (item.path) {
                    paths.add(item.path);
                }
                if (Array.isArray(item.subsections)) {
                    walk(item.subsections);
                }
            }
        };

        walk(sections);
        return paths;
    }

    /**
     * @param {{ pathname?: string } | null | undefined} location
     * @returns {string}
     */
    getNavbarCurrentPath(location) {
        return location?.pathname || window.location.pathname || '';
    }

    /**
     * Path passed to NavigationBar as `currentPath`.
     * NavigationBar already prefix-matches section.path against the URL
     * (e.g. /configurations/foo → /configurations, /support/ticket → /support).
     * Legacy routes that sit outside those prefixes are remapped via aliases.
     *
     * @param {{ pathname?: string } | null | undefined} location
     * @returns {string}
     */
    resolveNavbarActivePath(location) {
        const pathname = this.getNavbarCurrentPath(location);
        return NAVBAR_ACTIVE_PATH_ALIASES[pathname] ?? pathname;
    }

    /**
     * @param {string} path
     * @param {typeof navbarSections} [sections]
     * @returns {boolean}
     */
    isNavbarRoute(path, sections = navbarSections) {
        return path != null && this.collectNavbarPaths(sections).has(path);
    }

    /**
     * @param {string} path — from {@link navbarSections} entry `path`
     * @param {object} [section]
     */
    handleNavigate(path, section) {
        if (section?.onClick) {
            section.onClick(section);
            return;
        }
        if (!path || !this.isNavbarRoute(path)) {
            return;
        }
        if (this.props.navigate) {
            this.props.navigate(path);
        }
    }
}

export default NewSidebarController;
